import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  searchButton: css`
    button {
      background-color: ${colors.blue10};
      color: ${colors.blue90};
    }
    button:hover {
      background-color: ${colors.blue20} !important;
    }
  `,
}
